/**
 * ambientStyler.js
 * Contextual Ambient Lighting Accent Glow Engine
 * 
 * Dynamically computes brand accent hues from domain names and favicons,
 * providing subtle reactive ambient backlights on card hover.
 */

const PALETTE = [
  { name: 'emerald', hex: '#10b981', rgb: '16, 185, 129' },
  { name: 'cyan', hex: '#06b6d4', rgb: '6, 182, 212' },
  { name: 'violet', hex: '#a855f7', rgb: '168, 85, 247' },
  { name: 'amber', hex: '#f59e0b', rgb: '245, 158, 11' },
  { name: 'rose', hex: '#f43f5e', rgb: '244, 63, 94' },
  { name: 'cobalt', hex: '#3b82f6', rgb: '59, 130, 246' },
  { name: 'fuchsia', hex: '#d946ef', rgb: '217, 70, 239' },
  { name: 'lime', hex: '#84cc16', rgb: '132, 204, 22' },
  { name: 'teal', hex: '#14b8a6', rgb: '20, 184, 166' },
  { name: 'sky', hex: '#0ea5e9', rgb: '14, 165, 233' },
];

const colorCache = new Map();

/**
 * Deterministically computes an ambient glow style based on URL / domain.
 */
export function getAmbientGlow(url, isHovered = false) {
  if (!url) return null;

  if (colorCache.has(url)) {
    const item = colorCache.get(url);
    return isHovered ? item.hoverStyle : item.baseStyle;
  }

  let hash = 0;
  for (let i = 0; i < url.length; i++) {
    hash = (hash << 5) - hash + url.charCodeAt(i);
    hash |= 0;
  }
  const idx = Math.abs(hash) % PALETTE.length;
  const color = PALETTE[idx];

  const entry = {
    color,
    baseStyle: {
      accentColor: color.hex,
    },
    hoverStyle: {
      accentColor: color.hex,
      boxShadow: `0 8px 30px rgba(${color.rgb}, 0.22)`,
      borderColor: `rgba(${color.rgb}, 0.45)`,
    },
  };

  colorCache.set(url, entry);
  return isHovered ? entry.hoverStyle : entry.baseStyle;
}
